import {
  Box, 
  useRadio, 
  RadioProps,
} from '@chakra-ui/react';

type RadioComponentProps = {
  name?: string; 
  value: any, 
  isChecked: boolean,
  onChange: ()=>void,
} & RadioProps;  

export default function SRadio(props: RadioComponentProps) {
    const { getInputProps, getRadioProps } = useRadio(props);
    const input = getInputProps();
    const checkbox = getRadioProps();

    return (
        <Box as='label'>
          <input {...input} value={props.value} onChange={() => props.onChange(props.value)}/>
          <Box
            {...checkbox}
            cursor='pointer'
            color='brand.inputGrey'
            borderWidth='1px'
            border='1px solid'
            borderColor='brand.inputGrey'
            _checked={{
              borderColor: 'brand.black',
              color: 'brand.black',
            }}
            px={4}
            py={2}
            minWidth='88px'
            textAlign='center'
          >
            {props.children}
          </Box>
        </Box>
      );
}